<template>
    <div>
        <b-row class="mt-5">
        <b-col cols="4">
          <b-form-group label="From Date : "  :label-cols="3" >
            <v-date-picker
              mode="single"
              input-class="dateInput"
              :available-dates="{ start: null, end: new Date() }"
              v-model="fromDate"
            >
            </v-date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label="To Date : "  :label-cols="3" >
            <v-date-picker
              mode="single"
              input-class="dateInput"
              :available-dates="{ start: null, end: new Date() }"
              v-model="toDate"
            >
            </v-date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="4">
         <b-form-group label="Hub : "  :label-cols="2" >
           <b-form-select class="form-control input" v-model="destinationhubid">
             <option :value="null"  >--Select--</option>
                <option v-for="hub in hublist"   v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
            </b-form-select>          
          </b-form-group> 
        </b-col>
        <b-col cols="2" style="text-align:left;">
          <b-form-group>
            <button class="btn btn-primary" @click="getCODCollectionListing(1)"> Search </button>                       
            <button class="btn btn-danger ml-1" @click="refresh()"> <i class="fa fa-refresh"></i> </button>                       
          </b-form-group>
        </b-col>
        <b-col cols="2" style="text-align:right;">
          <b-form-group>
            <button class="btn btn-primary" @click="codCollection" :disabled="totalRows==0">Export </button>                       
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-2"> 
        <b-col sm="12" class="text-right">
          <b-col sm="12">  
            <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
          </b-col>
        </b-col> 

      <b-col sm="12">
        <b-table 
          show-empty 
          stacked="md"
          :busy="isBusy"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :bordered="bordered"
          >
          <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
          </div> 

          <!-- <template slot="uploaded_doc" slot-scope="row" >
            <p v-if="row.item.uploaded_doc != '' " 
                style="text-align: center; color:green"><a :href="row.item.uploaded_doc" download>
                <i class="fa fa-download"></i>
            </a></p>
          </template> -->

          <template slot="uploaded_doc" slot-scope="row">
            <b-button v-if="row.item.uploaded_doc.length > 0" size="sm" @click="openDocModal(row.item)">Show Docs</b-button>
          </template>

          <template slot="download" slot-scope="row">
            <button class="btn btn-primary">
              <i class="fa fa-download"></i>
            </button>
          </template>

          <template  slot="finance_status" slot-scope="row">
            <div v-if="row.item.status === 'Pending'">
              <b-form-select class="form-control input" v-model="row.item.status" @input="handleFinanceStatusChange(row)">
                <option value="Pending">Pending</option>
                <option value="Approved">Approve</option>
                <option value="Rejected">Reject</option>
              </b-form-select>
            </div>
            <div v-else>
              {{ row.item.status }}
            </div>
          </template>


          <template slot="show_logs" slot-scope="row">
            <b-button
              size="sm"
              @click="row.toggleDetails();logDetails(row.item.id,row.detailsShowing);"
              class="mr-2"
              style="background: #b0c4de !important;color: #000 !important;"
            >
              {{ row.detailsShowing ? "Hide" : "Show" }} Logs
            </b-button>
          </template>

          <template slot="row-details" slot-scope="row">
            <b-card title="Logs">
              <b-row>
                <b-table 
                  show-empty 
                  stacked="md"
                  :busy="isBusy"
                  :items="items2"
                  :fields="fields2"
                  >
                </b-table>
                <b-col sm="12">
                  <div slot="footer" class="text-right">
                    <b-button
                      size="sm"
                      @click="row.toggleDetails"
                      style="background: #b0c4de !important;color: #000 !important;"
                      >Hide Logs</b-button
                    >
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </template>

        </b-table>
      </b-col>

      <b-col sm="12" class="my-1 " v-if="this.totalRows > 10">
        <paginate 
          v-model="currentPage"
          :page-count="noofpages"
          :page-range="10"
          :margin-pages="2"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :container-class="'pagination'"
          :page-class="'page-item'">
        </paginate>
      </b-col> 

      <b-modal title="Reason for Reject" v-model="showRejectModal" @ok="submitRejectReason" @cancel="cancelRejectReason">
        <b-form @submit.prevent="submitRejectReason">
          <b-form-group  label-for="rejectReasonInput">
            <b-form-textarea id="rejectReasonInput" v-model="rejectReason" rows="3" required></b-form-textarea>
          </b-form-group>
          <!-- <div slot="modal-footer" class="text-right">
            <b-button type="submit" variant="primary" size="sm" @click="submitRejectReason">Submit</b-button>
            <b-button variant="danger" size="sm" @click="cancelRejectReason">Cancel</b-button>
          </div> -->
        </b-form>
      </b-modal>

      <b-modal v-model="docModal" title="Uploaded Docs" size="lg" hide-footer>
        <table class="table table-striped">
          <tr>
            <th >Document Name  </th>
              <th > Download </th>
            </tr>
            <tr v-for="file in showDocs">
              <td >{{ file.fileName }} </td>
              <td style="text-align: center;"> 
                <a  :href="file.fileUrl" download >
                  <i class="fa fa-download" v-b-tooltip.hover :title="file.fileName"></i>
                </a>
              </td>
            </tr>
        </table>

          </b-modal>
    </b-row>
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
export default{
    data: function(){
      return{
        name:'COD_collectionApproval',
        isBusy: false,
        items: [],
        fields: [
          {key:'hub_name',label:'HUB Name'},
          {key:'cod_collection_date',label:'Date of COD collection'},
          {key:'cod_submitted',label:'COD Amount Submitted'},
          {key:'deficient_amount',label:'Pending COD in Hub'},
          {key:'receipt_no',label:'Receipt Number'},
          {key:'remark',label:'Remark'},
          {key:'uploaded_doc',label:'Uploaded Receipt'},
          {key:'finance_status',label:'Finance Status'},
          { key: "show_logs", label: "Action" },       
        ],
        items2: [],
        fields2:[
         // {key:'cod_collection_date',label:'Date of COD'},
          {key:'created_date',label:'Log Date'},
          {key:'cod_submitted',label:'COD Amount'},
          {key:'status',label:'Status'},
          {key:'finance_query',label:'Reject Reason'},
        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        searching:'',
        noofpages:'',
        pageNum:1,

        toDate:new Date(),
        fromDate:new Date(),

        selectedStatus:[],
        destinationhubid:null,
        hublist:[],

        showRejectModal: false,
        rejectReason: '',

        rowid: null,
        rowStatus: '',
        downloadreport:'',

        showDocs: [],
        docModal: false,
      }
    },
    created: function(){
      this.getHublist();
      this.getCODCollectionListing(1);      
    },
    methods:{

      getHublist: function() {
        //this.lodershow=true;
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;
        var hubobj={
          hub_id:currenthub.toString()
        }

          this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,hubobj)
          .then(result => {
            //this.lodershow=false;
            if(result.body.returnmsg=='Successful'){
            this.hublist = result.body.returnvalue;
            }
            //console.log('mukesh',this.hublist);
          })
          .catch(ex => {
            console.log('error', ex)
          });
      },

      getCODCollectionListing: function(page){
        this.isBusy = true;

        if(this.fromDate > this.toDate){
          console.log('this.fromDate--->',this.fromDate);
          console.log('this.toDate--->',this.toDate);
          this.$fire({
            text: "From date must be smaller than To date",
            type: "warning",
            timer: 30000
          }); 
        }
        else{
          const Obj ={
            fromdate: this.formatDate(this.fromDate),
            todate: this.formatDate(this.toDate),
            hub_id: this.destinationhubid
          }

          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/approvedpaymentforSuperAdmin`,Obj)
            .then(result=>{
              this.isBusy = false;
              if(result.body.returnmsg === 'Successful'){
                this.items = result.body.returnvalue;
                this.totalRows = result.body.returnvalue.length;
                this.noofpages=parseInt(this.totalRows)/10;
                this.noofpages=Math.ceil( this.noofpages);
              }
              else{
                this.items = [];
                this.totalRows = 0;
              }
            })
          .catch(ex =>{
            console.log('error',ex)
          })
        }
      },

      logDetails(rowid,showhide){
        var showhides=showhide;

        if(showhides)
        {

        }
        else{
          const Obj={
            log_id : rowid,
            log_type: 'COD'
          }

          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getLogDataforFinance`,Obj)
            .then(result=>{
              if(result.body.returnmsg === 'Successful'){
                this.items2 = result.body.returnvalue;
              }
              else{
                this.items2 = [];
              }
            })
            .catch(ex =>{
              console.log('error',ex)
            })
        }
      },

      codCollection(){
        const Obj={
          fromdate: this.formatDate(this.fromDate),
          todate: this.formatDate(this.toDate),
          hub_id: this.destinationhubid
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/downloadCODCollectionLogForFinanceCSV`,Obj)
        .then(result=>{

          if(result.body){
            this.downloadReport(result.body)
          }
          else{
            this.downloadreport='';
          }
        })
        .catch(ex=>{
            console.log('error',ex)
        })
      },

      downloadReport(data){
        const csvData = data
        console.log("Data for download---> ",csvData);
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + csvData;
        anchor.download = 'CODCollectionLogForFinance.csv';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      },

      handleFinanceStatusChange(row) {
        this.rowid = row.item.id;
        this.rowStatus = row.item.status;
        if (row.item.status === 'Rejected') {
          this.showRejectModal = true;      
        }
        else{
          this.changeStatus()
        }
      },

      submitRejectReason(){
        this.changeStatus();
      },

      cancelRejectReason() {
        this.rejectReason = '';
        this.showRejectModal = false;
      },

      changeStatus(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var currentUser=userInfo.sysemailid;

        const Obj={
          req_id : this.rowid,
          action : this.rowStatus,
          comment : this.rejectReason,
          updated_by: currentUser
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/approveRejectCodClosureRequest`,Obj)
        .then(result=>{
          if(result.body.returnmsg === 'Successful'){
            this.$fire({
              text: "Status Changed Successfully!!!",
              type: "success",
              timer: 30000
            });
            this.rowid = null;
            this.rowStatus = '';
            this.rejectReason = '';
            this.getCODCollectionListing(1);
          }
          else{
            this.$fire({
              text: "Something went wrong!!!",
              type: "error",
              timer: 30000
            }); 
          }
          
        })
        .catch(ex =>{
          console.log('error',ex)
        })
        
      },

      openDocModal(files){
        this.showDocs = files.uploaded_doc;
        this.docModal = true;   
      },

      refresh(){
        this.fromDate = new Date();
        this.toDate = new Date();
        this.destinationhubid = null;
        this.getCODCollectionListing(1);
      },

      formatDate: function(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
      },
    }
}

</script>

<style>

</style>